import { cn } from "@/libs/utils";
import Image from "next/image";

interface Props {
  className?: string;
}

export default function MFMHorizontalOutline({ className }: Props) {
  return (
    <div className={cn("relative h-[32px] w-[145px]", className)}>
      <Image
        src="/svgs/mfm-horizontal-outline.svg"
        className="absolute object-contain"
        alt="MFM Horizontal Outline"
        fill
      />
    </div>
  );
}
